import React from 'react';
import { Image as ImageType } from '../../../commonTypes/image';
import { CallToAction } from '../../../commonTypes/links';
import componentProps, { ComponentProps } from '../../../helpers/componentProps';
import { applyComponentTheme } from '../../../theme';
import fluidGridColumns from '../../../theme/fluidGridColumns';
import { GridItemProps } from '../../Grid';
import {
  FeatureGrid,
  FeatureGridProps,
  ImageGridItem,
  StyledImage,
  TextGridItem,
} from './styles';

export type FeatureContainerProps = {
  cta?: CallToAction;
  image?: ImageType;
  renderImageAsLink?: boolean;
  children?: React.ReactNode;
} & FeatureGridProps &
  ComponentProps;

const FeatureContainer: React.FC<FeatureContainerProps> = ({
  cta,
  image,
  invertContent,
  invertContentOnMobile,
  renderImageAsLink,
  children,
  ...props
}) => {
  const imageGridItemProps: GridItemProps = {
    desktop: 4,
    tabletLandscape: 4,
    tabletPortrait: 3,
    mobile: fluidGridColumns.mobile,
  };

  const textGridItemProps: GridItemProps = {
    desktop: image ? 6 : 10,
    tabletLandscape: image ? 6 : 10,
    tabletPortrait: image ? 5 : fluidGridColumns.tabletPortrait,
    mobile: fluidGridColumns.mobile,
  };

  return (
    <FeatureGrid
      invertContent={invertContent}
      invertContentOnMobile={invertContentOnMobile}
      {...componentProps(props)}>
      {image && (
        <ImageGridItem {...imageGridItemProps}>
          <StyledImage
            image={image}
            link={
              renderImageAsLink === true && cta?.url
                ? {
                    url: cta.url,
                    onClick: cta.onClick,
                    screenReaderText: cta.screenReaderText,
                  }
                : undefined
            }
            invertContentOnMobile={invertContentOnMobile}
          />
        </ImageGridItem>
      )}
      <TextGridItem {...textGridItemProps}>{children}</TextGridItem>
    </FeatureGrid>
  );
};

export default applyComponentTheme(FeatureContainer, 'FeatureContainer');
